import PostAuthor from './post-author';

export default PostAuthor;
